import { Code, Briefcase, LineChart, Brain, Server, Palette } from 'lucide-react';

export const paths = [
  {
    title: "Software Development",
    description: "Build the future with code. Learn programming, web development, and software engineering.",
    icon: <Code className="w-6 h-6 text-blue-400" />,
    gradient: "from-blue-400 to-cyan-400",
    popular: true
  },
  {
    title: "Business & Management",
    description: "Master business strategy, leadership, and organizational management.",
    icon: <Briefcase className="w-6 h-6 text-purple-400" />,
    gradient: "from-purple-400 to-pink-400"
  },
  {
    title: "Data Science",
    description: "Unlock insights from data through analytics, machine learning, and statistics.",
    icon: <LineChart className="w-6 h-6 text-green-400" />,
    gradient: "from-green-400 to-emerald-400"
  },
  {
    title: "AI & Machine Learning",
    description: "Explore artificial intelligence, deep learning, and neural networks.",
    icon: <Brain className="w-6 h-6 text-red-400" />,
    gradient: "from-red-400 to-rose-400"
  },
  {
    title: "Cloud Computing",
    description: "Master cloud platforms, DevOps, and infrastructure management.",
    icon: <Server className="w-6 h-6 text-amber-400" />,
    gradient: "from-amber-400 to-orange-400"
  },
  {
    title: "UI/UX Design",
    description: "Create beautiful, user-friendly interfaces and experiences.",
    icon: <Palette className="w-6 h-6 text-indigo-400" />,
    gradient: "from-indigo-400 to-violet-400"
  }
] as const;

export type CareerPath = typeof paths[number]; 